import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration } from "types/generated";

export type AiIntegrationView = Pick<
  AiIntegration,
  "id" | "name" | "description" | "labels" | "provider" | "model"
> & {
  space: Pick<NonNullable<AiIntegration["space"]>, "id" | "name" | "accessLevel">;
};

type SearchAiIntegrationsData = {
  aiIntegrations: AiIntegrationView[];
};

export const SEARCH_AI_INTEGRATIONS: TypedDocumentNode<SearchAiIntegrationsData> = gql`
  query SearchAiIntegrations {
    aiIntegrations {
      id
      name
      description
      labels
      provider
      model
      space {
        id
        name
        accessLevel
      }
    }
  }
`;
